export const PORTFOLIO_SMART_INSIGHTS_SORT_OPTIONS = {
  PRIORITY: 'priority',
  STAY_DATE: 'stayDate',
} as const;

export type PortfolioSmartInsightsSortOption =
  (typeof PORTFOLIO_SMART_INSIGHTS_SORT_OPTIONS)[keyof typeof PORTFOLIO_SMART_INSIGHTS_SORT_OPTIONS];

export const PORTFOLIO_SMART_INSIGHTS_AGGREGATION_OPTIONS = {
  STAY_DATE: 'stayDate',
  HOTEL: 'hotel',
} as const;

export type PortfolioSmartInsightsAggregationOption =
  (typeof PORTFOLIO_SMART_INSIGHTS_AGGREGATION_OPTIONS)[keyof typeof PORTFOLIO_SMART_INSIGHTS_AGGREGATION_OPTIONS];
